import { isPlainObject } from 'lodash'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { ServerConfig } from '@/config/server-config'
import { HttpOption, RESTFul } from '@/utils/http-client'

export class BaseService {
    protected request: (opt: HttpOption) => Observable<any>
    protected requestPmc: (opt: HttpOption) => Observable<any>

    constructor() {
        /** 支付管理的请求方法 */
        this.requestPmc = (opt: HttpOption) => {
            // 实例化一个请求方法
            return new RESTFul()
                .request({
                    ...changeOptionData(opt, opt.data || opt.params),
                    baseURL: ServerConfig.PaymentUrl
                })
                .pipe(map(handleResponse))
        }

        /** 资金管理的请求方法 */
        this.request = (opt: HttpOption) => new RESTFul().request(opt).pipe(map(handleResponse))
    }
}

const handleResponse = (response) => {
    if (response.data) {
        if (response.data.data === 0) {
            return response.data.data
        }
        return response.data.data ? response.data.data : response.data
    }
    return response
}

/**
 * 修改请求参数data
 * @param opt
 */
const changeOptionData = (opt, data) => {
    if (isPlainObject(data)) {
        let { current, size, ...data_ } = JSON.parse(JSON.stringify(data))
        Object.keys(data_).map(i => (data[i] === null || data_[i] === '' ? delete data_[i] : null))
        current && (data_.pageNum = current)
        size && (data_.pageSize = size)
        opt.params ? (opt.params = data_) : (opt.data = data_)
    }

    // console.log(JSON.stringify(opt), isPlainObject(opt.data))
    return opt
}
